var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup__layer active" }, [
    _c("div", { staticClass: "popup__edit big" }, [
      _c("div", { staticClass: "gl-popup__title" }, [
        _vm._v(" " + _vm._s(_vm.$t(`account.edit.logo`)) + " ")
      ]),
      _c("div", { staticClass: "gl-popup__close", on: { click: _vm.close } }, [
        _c("span", { staticClass: "glicon-close-large" })
      ]),
      _c(
        "div",
        {
          ref: "drag",
          staticClass: "gl-popup__upload",
          style: _vm.isOver
            ? "background-color: rgba(0, 126, 255, 0.2);"
            : null,
          on: {
            dragover: function($event) {
              $event.preventDefault()
            },
            drop: [
              function($event) {
                $event.preventDefault()
              },
              _vm.onFileDrop
            ]
          }
        },
        [
          _c("vue-cropper", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.image,
                expression: "image"
              }
            ],
            ref: "cropper",
            staticClass: "logo",
            attrs: { src: _vm.selectedFile, alt: "Source Image" }
          }),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.image,
                expression: "!image"
              }
            ],
            staticClass: "glicon-px-image"
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.image,
                  expression: "!image"
                }
              ],
              staticClass: "label"
            },
            [_vm._v(_vm._s(_vm.$t("account.edit.logoActions.drag")))]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.image,
                  expression: "!image"
                }
              ],
              staticClass: "link"
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("nouns.or")) + " "),
              _c(
                "label",
                {
                  staticClass: "select-img-text",
                  attrs: { for: "account.upload" }
                },
                [_vm._v(_vm._s(_vm.$t("account.edit.logoActions.upload")))]
              ),
              _c("input", {
                ref: "fileInput",
                staticClass: "upload-img",
                attrs: {
                  id: "account.upload",
                  type: "file",
                  name: "logo",
                  accept: "image/*"
                },
                on: { change: _vm.onFileSelect }
              })
            ]
          ),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.image,
                expression: "!image"
              }
            ],
            staticClass: "separator"
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.image,
                  expression: "!image"
                }
              ],
              staticClass: "label small"
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("account.edit.logoActions.recommendedOrientation")
                )
              )
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.image,
                  expression: "!image"
                }
              ],
              staticClass: "label small"
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("account.edit.logoActions.dragAndDropMaxImageSize", {
                    sizeInMb: _vm.sizeInMb
                  })
                )
              )
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.image,
                  expression: "!image"
                }
              ],
              staticClass: "label small"
            },
            [_vm._v(_vm._s(_vm.$t("account.edit.logoActions.validFormat")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "popup__buttons normal" },
        [
          !_vm.image
            ? _c("gl-button", {
                attrs: {
                  id: "account.btn-update",
                  "color-secondary": "",
                  type: "button",
                  text: _vm.$t("actions.cancel")
                },
                on: {
                  onClick: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              })
            : _c("gl-button", {
                attrs: {
                  id: "account.btn-remove-img",
                  "color-secondary": "",
                  type: "button",
                  text: _vm.$t("actions.removeImg")
                },
                on: {
                  onClick: function($event) {
                    $event.preventDefault()
                    return _vm.removeFile.apply(null, arguments)
                  }
                }
              }),
          _c("gl-button", {
            attrs: {
              id: "account.btn-update",
              "color-primary": "",
              type: "button",
              text: _vm.$t("account.forms.save"),
              disabled: !_vm.image
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.uploadImage.apply(null, arguments)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }